import { PDF, PaperclipAttachment } from 'seagull/icons';
export const attachmentIcon = (fileName)=>fileName.toLowerCase().endsWith('.pdf') ? PDF : PaperclipAttachment;
